export const ENV = process.env.ENV
export const API = process.env.REACT_APP_API_URL
export const BASIC_AUTH = process.env.REACT_APP_BASIC_AUTH
export const FACEBOOK_APP_ID = process.env.FACEBOOK_APP_ID
export const GOOGLE_CLIENT_ID = process.env.GOOGLE_CLIENT_ID
export const GOOGLE_API_KEY = process.env.GOOGLE_API_KEY
export const APPLE_CLIENT_ID = process.env.APPLE_CLIENT_ID
export const APPLE_REDIRECT_URI = process.env.APPLE_REDIRECT_URI